export function Play2() {
  return (
    <g fill="currentColor">
      <path d="M31.295 25.273l-12 7.5c-.243.151-.519.228-.795.228-.25 0-.5-.062-.727-.189-.477-.264-.773-.766-.773-1.311v-15c0-.546.296-1.048.773-1.312.477-.266 1.06-.25 1.522.04l12 7.5c.438.274.705.755.705 1.272s-.267.997-.705 1.272" />
      <path d="M24 45.905C11.922 45.905 2.095 36.078 2.095 24 2.095 11.922 11.922 2.095 24 2.095c12.078 0 21.905 9.827 21.905 21.905 0 12.078-9.827 21.905-21.905 21.905M24 0C17.59 0 11.562 2.496 7.03 7.03 2.495 11.561 0 17.59 0 24c0 6.41 2.496 12.438 7.03 16.97C11.561 45.504 17.59 48 24 48c6.41 0 12.438-2.496 16.97-7.03C45.504 36.438 48 30.41 48 24c0-6.41-2.496-12.438-7.03-16.97C36.438 2.495 30.41 0 24 0z" />
    </g>
  )
}
